import { useEffect, useState } from "react";
import ServiceSection from "./ServiceSection";
import ServiceTerminal from "./ServiceTerminal";

const SERVICE_HERO_STORAGE_KEY = "serviceHeroOpen";

export default function ServiceHero({ defaultOpen = false, isOpen: controlledOpen, onToggle }) {
  const isControlled = typeof controlledOpen === "boolean" && typeof onToggle === "function";
  const [isOpen, setIsOpen] = useState(() => {
    if (typeof window === "undefined") return defaultOpen;
    const stored = window.sessionStorage.getItem(SERVICE_HERO_STORAGE_KEY);
    if (stored === "1") return true;
    if (stored === "0") return false;
    return defaultOpen;
  });

  useEffect(() => {
    if (isControlled) return;
    if (typeof window === "undefined") return;
    window.sessionStorage.setItem(SERVICE_HERO_STORAGE_KEY, isOpen ? "1" : "0");
  }, [isOpen, isControlled]);

  useEffect(() => {
    if (isControlled) return;
    return () => {
      if (typeof window === "undefined") return;
      window.sessionStorage.removeItem(SERVICE_HERO_STORAGE_KEY);
    };
  }, [isControlled]);

  const open = isControlled ? controlledOpen : isOpen;
  const handleToggle = isControlled ? onToggle : () => setIsOpen((v) => !v);

  return (
    <div className="servicehero-area">
      <div className="mt-0">
        <ServiceSection onToggle={handleToggle} isOpen={open} />
      </div>
      <div
        className={`mt-0 overflow-hidden transform-gpu transition-[max-height,transform] duration-700 ease-out will-change-[max-height,transform] ${
          open
            ? "max-h-[2200px] translate-y-0"
            : "max-h-0 -translate-y-2 pointer-events-none"
        }`}
        aria-hidden={!open}
      >
        <ServiceTerminal />
      </div>
    </div>
  );
}
